export default __webpack_public_path__ + "static/media/Referrals.9bc7c188.svg";